module.exports = __webpack_public_path__ + "img/ts11.b5026b20.png";